"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const InfoBox = (props) => {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-info-box', props.className) },
        props.title ? react_1.default.createElement("div", { className: "znd-info-box__title t-subhead-1" }, props.title) : null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-info-box__text', 't-body-small', { 'pb-0': !props.title }), dangerouslySetInnerHTML: { __html: props.innerHtml } }),
        props.link ?? null));
};
exports.default = (0, mobx_react_1.observer)(InfoBox);
